const ValidRanges = {
  MAX_DAY: 31,
  MIN_DAY: 1,
  MAX_MONTH: 12,
  MIN_MONTH: 1,
  MAX_YEAR: 9999,
  MIN_YEAR: 1900,
  MAX_MONTHS_AT_ADDRESS: 12,
  MIN_MONTHS_AT_ADDRESS: 0,
  MAX_YEARS_AT_ADDRESS: 150,
  MIN_YEARS_AT_ADDRESS: 0
};

export default ValidRanges;



/** WEBPACK FOOTER **
 ** ./src/common/validation/ValidRanges.js
 **/